// extracted by mini-css-extract-plugin
module.exports = {"status-value":"portal-component-module__eI2luW__status-value","login-box":"portal-component-module__eI2luW__login-box","portal":"portal-component-module__eI2luW__portal"};